// client/src/utils/GoalLevelUtils.js
import StringUtils from './StringUtils';

const DEVELOPMENTAL_LEVELS = [
  { level: 1, minAge: 0, maxAge: 2, description: "0-2 years" },
  { level: 2, minAge: 3, maxAge: 3, description: "3 years" },
  { level: 3, minAge: 4, maxAge: 4, description: "4 years" },
  { level: 4, minAge: 5, maxAge: 5, description: "5 years" },
  { level: 5, minAge: 6, maxAge: 6, description: "6 years" },
  { level: 6, minAge: 7, maxAge: 7, description: "7 years" },
  { level: 7, minAge: 8, maxAge: 8, description: "8 years" },
  { level: 8, minAge: 9, maxAge: 12, description: "9-12 years" },
  { level: 9, minAge: 13, maxAge: 18, description: "13-18 years" },
  { level: 10, minAge: 19, maxAge: 999, description: "19+ years" }
];

function getCurrentDevelopmentalLevel(dob) {
  const age = StringUtils.getAgeFromDOB(dob);
  const level = DEVELOPMENTAL_LEVELS.find(level =>
    age >= level.minAge && age <= level.maxAge
  );
  return level || DEVELOPMENTAL_LEVELS[DEVELOPMENTAL_LEVELS.length - 1];
}

function getGoalLevel(dob) {
  const currentLevel = getCurrentDevelopmentalLevel(dob);
  const goalLevelNumber = Math.min(currentLevel.level + 1, 10);
  return DEVELOPMENTAL_LEVELS.find(level => level.level === goalLevelNumber);
}

const GoalLevelUtils = {
  getCurrentDevelopmentalLevel,
  getGoalLevel,
  DEVELOPMENTAL_LEVELS
};

export default GoalLevelUtils;